import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import HomepageConstructionIntelligenceHub from "pages/homepage-construction-intelligence-hub";
import SuccessStoriesProjectTransformations from "pages/success-stories-project-transformations";

import AboutNirmiteeConstructionIntelligenceStory from "pages/about-nirmitee-construction-intelligence-story";
import ProjectsPage from "pages/projects-portfolio-showcase";
import ProjectDetail from "pages/project-detail";
import BlogPage from "pages/blog";
import BlogDetail from "pages/blog-detail";
import AdminPanel from "pages/admin-panel-content-management-system";
import PrivacyPolicy from "pages/legal/PrivacyPolicy";
import TermsOfService from "pages/legal/TermsOfService";
import CookiePolicy from "pages/legal/CookiePolicy";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={<HomepageConstructionIntelligenceHub />} />
          <Route path="/success-stories-project-transformations" element={<SuccessStoriesProjectTransformations />} />

          <Route path="/aboutUs" element={<AboutNirmiteeConstructionIntelligenceStory />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/project/:projectId" element={<ProjectDetail />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:blogId" element={<BlogDetail />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;